import { ChatPackage, getChatClient } from '@packages/chat'
import { ProfilesPackage } from '@packages/profiles'
import { ThemePackage } from '@packages/theme'
import { MediasPackage } from '@packages/medias'
import { api } from './api'
import baseColors from './styles/colors/baseColors'
import draftMode from './styles/colors/draftMode'
import { IS_SSR } from './constants'
import { IsDevEnv } from './Settings'
import { getConfig } from '@packages/config'
import { queryClient } from './queryClient'

export const GetStreamConfig = getConfig({
  getEnv: () => null,
}, IsDevEnv ? 'development' : 'production')
// Singleton to use ChatPackage
export const Chat = new ChatPackage({
  api,
  queryClient,
  getChatClient: (options) => {
    return getChatClient(GetStreamConfig.values.chatApiKey, options || { connectUser: false })
  },
})
export const Profiles = new ProfilesPackage(api)
const MEDIA_TOKEN_STORAGE_KEY = 'MEDIA_TOKEN'

export const Medias = new MediasPackage({
  cdnBaseUrl: () => GetStreamConfig.values.cdnBaseUrl,
  tokenStore: {
    get: () => {
      if (IS_SSR) return null
      return localStorage.getItem(MEDIA_TOKEN_STORAGE_KEY)
    },
    set: (token) => {
      if (IS_SSR) return
      localStorage.setItem(MEDIA_TOKEN_STORAGE_KEY, token)
    },
    remove: () => {
      if (IS_SSR) return
      localStorage.removeItem(MEDIA_TOKEN_STORAGE_KEY)
    },
  },
  api,
})
export const CompanyTheme = new ThemePackage(api, {
  baseColors,
  draftMode,
  getTheme: async () => {
    const { theme } = await import('./styles/theme')
    return theme
  },
  colorStore: {
    set: (colors) => {
      if (IS_SSR) return

      localStorage.setItem('BASECOLOR_CACHE', JSON.stringify(colors))
    },
    get: () => {
      if (IS_SSR) return {}
      const val = localStorage.getItem('BASECOLOR_CACHE')

      if (!val) return {}

      return JSON.parse(val)
    },
    remove: () => {
      if (IS_SSR) return

      localStorage.removeItem('BASECOLOR_CACHE')
    },
  },

}, IsDevEnv)

